var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PercentageChangeBar"},[_c('div',{class:_vm.classes,style:(_vm.styles)}),_vm._v(" "),_c('div',{class:_vm.figureClasses,domProps:{"innerHTML":_vm._s(_vm.displayFigure)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }